import axios from 'axios'

// create an axios instance
var service = axios.create({
  baseURL: 'https://transportesclmback.uniteldesarrollo.com',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
})

export default service
